import { useTranslationContext } from "@providers/TranslationProvider";
import styles from "./OurLocation.module.scss";
import Select from "@components/Formik/Select";
import Image from "@components/Image";
import Markdown from "@components/Markdown";
import cx from "classnames";
import _ from "lodash";
import { useFormik, Form } from "formik";
import FormProvider from "@providers/FormProvider";
import Button from "@components/Button";
import Link from "@components/Link";
import { useRouteContext } from "@providers/RouteProvider";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";

const View = () => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const data = discoverPage.formatOurLocation(pageData);
  const form = useFormik({
    initialValues: {
      location: "1",
    },
    onSubmit: () => {},
  });
  const service = _.get(data, "services.0");
  return (
    <FormProvider form={form}>
      <Form>
        <section className={cx(styles.section)} data-scroll-section>
          <div className={cx("inner-large", styles.box)}>
            <div className={styles.contentBox}>
              <label className={cx("ama-label text-yellow-1")}>
                {i18n.t("Discover.BlockOurLocation.ourLocation")}
              </label>
              <div className={cx("ama-section-title", styles.title)}>
                {_.get(data, "title")}
                {/* <Trans
                  i18nKey="Discover.BlockOurLocation.getting"
                  components={[<br key="trans_1" />]}
                /> */}
              </div>
              <div className={cx("ama-content", styles.address)}>
                {_.get(data, "address")}
                {/* {i18n.t("Discover.BlockOurLocation.address")} */}
              </div>
              <div className={styles.tel}>
                {i18n.t("Discover.BlockOurLocation.tel")}:{" "}
                <span className={styles.phone}>
                  <Link href={`tel:${_.get(data, "phone")}`}>
                    {_.get(data, "phone")}
                  </Link>
                  {/* {i18n.t("Discover.BlockOurLocation.phone")} */}
                </span>
              </div>
              <div className={styles.selectBox}>
                <Select
                  optionCapitalize
                  className={styles.select}
                  theme="dark"
                  name="location"
                  options={[
                    {
                      label: _.get(service, "name"),
                      value: "1",
                    },
                  ]}
                />
              </div>
              <div className={styles.description}>
                <Markdown content={_.get(service, "description")} />

                {/* <Trans
                  i18nKey="Discover.BlockOurLocation.airportDescription"
                  components={[<br key="trans_0" />]}
                /> */}
              </div>
              <div className={styles.button}>
                <Button
                  onClick={() => {
                    const link = _.get(service, "mapLink");
                    if (link) {
                      router.open(link);
                    }
                  }}
                  type="icon"
                  color="yellow"
                  label={i18n.t("Button.goToMap")}
                  suffix="shape-arrow"
                />
              </div>
            </div>
            <div className={styles.mapBox}>
              <Image
                {..._.get(service, "image")}
                alt={_.get(service, "image.alt") || _.get(service, "name") || "Location map"}
                onClick={() => {
                  const link = _.get(service, "mapLink");
                  if (link) {
                    router.open(link);
                  }
                  // router.open(
                  //   "https://www.google.com/maps/place/Amanaki+Thao+Dien+Hotel/@10.801774,106.7345886,18.43z/data=!4m9!3m8!1s0x31752724994128d7:0x3af0ae64a058f117!5m2!4m1!1i2!8m2!3d10.801858!4d106.735494!16s%2Fg%2F11n85ftgr1"
                  // );
                }}
                wrapperProps={{ className: cx("cursor-pointer", styles.image) }}
                // src={"/discover/map.jpg"}
                // alt={""}
                layout="fill"
              />
            </div>
          </div>
        </section>
      </Form>
    </FormProvider>
  );
};
export default View;
